export default "__VITE_ASSET__C33fc9_P__"